module.exports = __webpack_public_path__ + "img/streamer.81685775.png";